import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './admin-content-reviews.loaders';
import { adminContentReviewsKeys } from './admin-content-reviews.queries';

export const useApproveContentReview = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.approveContentReview, {
    onSuccess: () => queryClient.invalidateQueries(adminContentReviewsKeys.all),
  });
};

export const useRejectContentReview = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.rejectContentReview, {
    onSuccess: () => queryClient.invalidateQueries(adminContentReviewsKeys.all),
  });
};
